var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"theme-color",staticStyle:{"height":"100%"},attrs:{"fluid":""}},[_c('v-row',{staticClass:"card pb-4 mt-5",attrs:{"justify-space-between":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('Report')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }